import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const ShowOption = (props) => {
	const { t, i18n } = useTranslation();

	const {showOption, setShowOption} = props;

	const onChange = (e) => {
		const value = e.target.value;

		setShowOption(value);
	}

	return (
		<div className="d-flex align-items-center">
		    <select
		    	className="form-select form-select-sm view-select-Toggle"
		    	value={showOption}
		    	onChange={onChange}
		    >
		        <option value="all" className="fs-7">{t('顯示所有選項')}</option>
		        <option value="selected" className="fs-7">{t('顯示已勾選的')}</option>
		    </select>
		</div>
	);
}

export default ShowOption;